/* Only supporting videos opt into these shared observers and lifecycle hooks. */
(() => {
  'use strict';
  if (window.GrowplayLazyVideo) return;
  const videos = new Map();
  let nextVideoId = 0;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const load = video => {
    if (video.dataset.gpVideoLoaded) return;
    video.dataset.gpVideoLoaded = 'true';
    video.querySelectorAll('source[data-gp-src]').forEach(source => { source.src = source.dataset.gpSrc; });
    video.preload = 'metadata';
    video.load();
  };
  const sync = (video, state) => {
    if (!state.visible || document.hidden || state.userPaused || (!state.explicit && (motion.matches || navigator.connection?.saveData))) {
      if (!video.paused) state.ignorePause = true;
      video.pause();
    } else if (state.explicit || video.dataset.gpAutoplay === 'true') {
      load(video);
      state.automaticPlay = !state.explicit;
      video.play().catch(() => {});
    }
  };
  const loading = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
    if (isIntersecting && !motion.matches && !navigator.connection?.saveData) load(target);
  }), {rootMargin:'300px 0px'});
  const playback = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting,intersectionRatio}) => {
    const state = videos.get(target);
    if (!state) return;
    state.visible = isIntersecting && intersectionRatio >= .5;
    sync(target,state);
  }), {threshold:[0,.5]});
  function init(root) {
    root.querySelectorAll('video[data-gp-lazy-video]').forEach(video => {
      if (videos.has(video)) return;
      if (!video.getAttribute('aria-label')) {
        const section = video.closest('.shopify-section');
        const heading = section?.querySelector('h1, h2, h3');
        video.setAttribute('aria-label', heading?.textContent.trim() || document.title);
      }
      if (!video.id) video.id = `gp-support-video-${++nextVideoId}`;
      const state = {visible:false,userPaused:false,explicit:false};
      if (video.dataset.gpAutoplay === 'true' && !video.controls) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gp-video-toggle';
        button.setAttribute('aria-controls', video.id);
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('width', '20');
        icon.setAttribute('height', '20');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        const symbol = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        symbol.setAttribute('fill', 'currentColor');
        icon.append(symbol);
        button.append(icon);
        const label = () => {
          const action = video.paused ? (window.PXUTheme?.translation?.video_play || 'Play video') : (window.PXUTheme?.translation?.video_pause || 'Pause video');
          symbol.setAttribute('d', video.paused ? 'M8 5v14l11-7Z' : 'M6 5h4v14H6ZM14 5h4v14h-4Z');
          button.dataset.state = video.paused ? 'paused' : 'playing';
          button.setAttribute('aria-label', `${action}: ${video.getAttribute('aria-label') || ''}`);
        };
        state.button = button;
        state.update = label;
        state.toggle = () => {
          state.userPaused = !video.paused;
          state.explicit = video.paused;
          sync(video,state);
        };
        button.addEventListener('click', state.toggle);
        ['play','pause','ended'].forEach(event => video.addEventListener(event,label));
        video.parentElement.style.position = 'relative';
        video.after(button);
        label();
      }
      if (video.controls) {
        state.onPause = () => {
          if (state.ignorePause) state.ignorePause = false;
          else state.userPaused = true;
        };
        state.onPlay = () => {
          if (state.automaticPlay) state.automaticPlay = false;
          else {state.userPaused = false;state.explicit = true;}
        };
        video.addEventListener('pause',state.onPause);
        video.addEventListener('play',state.onPlay);
      }
      videos.set(video,state);
      loading.observe(video);
      playback.observe(video);
    });
  }
  const syncAll = () => videos.forEach((state,video) => sync(video,state));
  motion.addEventListener('change', () => {videos.forEach(state => state.explicit=false);syncAll();});
  document.addEventListener('visibilitychange',syncAll);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => videos.forEach((state,video) => {
    if (!event.target.contains(video)) return;
    loading.unobserve(video);
    playback.unobserve(video);
    video.pause();
    if (state.onPause) video.removeEventListener('pause',state.onPause);
    if (state.onPlay) video.removeEventListener('play',state.onPlay);
    state.button?.removeEventListener('click',state.toggle);
    if (state.update) ['play','pause','ended'].forEach(name => video.removeEventListener(name,state.update));
    state.button?.remove();
    videos.delete(video);
  }));
  window.GrowplayLazyVideo = {init};
  init(document);
})();
